import React from 'react';
import draftToHtml from 'draftjs-to-html';
import { RawDraftContentState } from 'draft-js';

const RichTextContent: React.FC<{
  children: RawDraftContentState;
  className?: string;
  extraClasses?: string;
}> = ({
  children,
  className = 'mt-4 prose w-full max-w-full pr-4',
  extraClasses = '',
}) => {
  let markup = draftToHtml(children, {
    trigger: '',
    separator: ' ',
  });

  return (
    <div
      className={`${className} ${extraClasses}`}
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
};

export default RichTextContent;
